<template>
  <Inventory />
</template>

<script>
import Inventory from "@/components/inventory/Inventory.vue";

export default {
  name: "InventoryPage",
  routing: {
    localizationKey: "menu.tab.inventory",
    icon: "mdi-package-variant",
    path: "/inventory",
    hasAccess: (user) => user.isAdmin || user.isManager,
  },

  components: {
    Inventory,
  },
};
</script>
